import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

//dependencys
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

//components
import LoginPage from './components/LoginPage/LoginPage';
import Page404 from './components/404/Page404';
import Dashboard from './components/DashBoard/Dashboard';

//Pages
import ForShowDash from './components/Pages/mainPageDash/ForShowDash';
import Users from './components/Pages/Users/Users';
import EditeUser from './components/Pages/Users/EditeUser';
import ShowTemplates from './components/Pages/Templates/ShowTemplates';
import InstallTemplate from './components/Pages/installTemplates/InstallTemplate';
import EditeTemplate from './components/Pages/Templates/EditeTemplate';
import DetailTemplate from './components/Pages/Templates/DetailTemplate';
import DetailLanding from './components/Pages/Landings/DetailLanding';
import Profile from './components/Pages/ProfilePage/Profile';
import ShowLandings from './components/Pages/Landings/ShowLandings';
import InstallLanding from './components/Pages/installLandings/InstallLanding';
import EditeLanding from './components/Pages/Landings/EditeLanding';
import CopyLanding from './components/Pages/Landings/CopyLanding';
import TrashList from './components/Pages/Trashes/TrashList';
import ShowStatistics from './components/Pages/Statistics/ShowStatistics';
import DetailStatistics from './components/Pages/Statistics/DetailStatistics';
import RolesPage from './components/Pages/Roles/RolesPage';
import EditeRole from './components/Pages/Roles/EditeRole';

//shared
import ContentDashboard from './shared/ContentDashboard';
import { responseHandler } from './functions/responseHandler';
import Logs from './components/Pages/Landings/logs';
import Groups from './components/Pages/groups/groups';
import EditeGroup from './components/Pages/groups/EditeGroup';
import Gallery from './components/Pages/gallery/gallery';

//context
export const myUserDataContext = React.createContext();

const App = () => {
  //for useeffect dependency in dashboard for update localStroage
  const [UpdateLocalStorage, setUpdateLocalStorage] = useState(false);

  // for check user login in past or not
  const pastLogin = JSON.parse(localStorage.getItem('isLogin'));
  const pastUserData = JSON.parse(localStorage.getItem('userData'));

  const [userData, setUserData] = useStateWithCallbackLazy(
    pastUserData === null ? {} : pastUserData,
  );
  const [isLogin, setIsLogin] = useStateWithCallbackLazy(
    pastLogin === null ? false : pastLogin,
  );

  //for search in hole of dashboard
  const [keySearch, setKeySearch] = useState(false);

  // const baseUrl = document.getElementById('baseUrl').value;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  //for show Landing Link in showLandings
  const mainUrl = baseUrl;

  return (
    <myUserDataContext.Provider
      value={{
        userData,
        setUserData,
        isLogin,
        setIsLogin,
        UpdateLocalStorage,
        setUpdateLocalStorage,
        mainUrl,
        keySearch,
        setKeySearch,
      }}
    >
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <LoginPage
                setUserData={setUserData}
                setIsLogin={setIsLogin}
                isLogin={isLogin}
              />
            }
          />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route
              path="/dashboard"
              element={
                <ContentDashboard
                  title="داشبورد"
                  content={<ForShowDash />}
                />
              }
            />

            <Route
              path="profile"
              element={
                <ContentDashboard
                  title="پروفایل"
                  content={<Profile />}
                />
              }
            />

            <Route
              path="users/trash-list"
              element={
                <ContentDashboard
                  title="سطل زباله کاربران"
                  content={<TrashList show="user" />}
                />
              }
            />
            <Route
              path="showLandings/sho:id"
              element={
                <ContentDashboard
                  title="جزئیات لندینگ"
                  content={<DetailLanding />}
                />
              }
            />
            <Route
              path="users/edite/:id"
              element={
                <ContentDashboard
                  title="ویرایش کاربر"
                  content={<EditeUser />}
                />
              }
            />
            <Route
              path="users"
              element={
                <ContentDashboard
                  title="کاربران"
                  content={<Users />}
                />
              }
            />
            <Route
              path="groups"
              element={
                <ContentDashboard
                  title="گروه ها"
                  content={<Groups />}
                />
              }
            />

            <Route
              path="group/edite/:id"
              element={
                <ContentDashboard
                  title="ویرایش گروه"
                  content={<EditeGroup />}
                />
              }
            />

            <Route
              path="installTemplate"
              element={
                <ContentDashboard
                  title="نصب قالب جدید"
                  content={<InstallTemplate />}
                />
              }
            />

            <Route
              path="showTemplates/trash-list"
              element={
                <ContentDashboard
                  title="سطل زباله قالب ها"
                  content={<TrashList show="template" />}
                />
              }
            />
            <Route
              path="showLandings/logs/:id"
              element={
                <ContentDashboard
                  title="لاگ تغییرات"
                  content={<Logs />}
                />
              }
            />
            <Route
              path="showTemplates/edite/:id"
              element={
                <ContentDashboard
                  title="ویرایش قالب"
                  content={<EditeTemplate />}
                />
              }
            />
            <Route
              path="showTemplates"
              element={
                <ContentDashboard
                  title="نمایش قالب ها"
                  content={<ShowTemplates />}
                />
              }
            />

            <Route
              path="showLandings/trash-list"
              element={
                <ContentDashboard
                  title="سطل زباله لندینگ ها"
                  content={<TrashList show="landing" />}
                />
              }
            />
            <Route
              path="showLandings/:id"
              element={
                <ContentDashboard
                  title="جزئیات لندینگ"
                  content={<DetailLanding />}
                />
              }
            />
            <Route
              path="showLandings/newofcopy/:id"
              element={
                <ContentDashboard
                  title="ایجاد لندینگ کپی"
                  content={<CopyLanding />}
                />
              }
            />
            <Route
              path="showLandings/edite/:id"
              element={
                <ContentDashboard
                  title="ویرایش لندینگ"
                  content={<EditeLanding />}
                />
              }
            />
            <Route
              path="showLandings/installLanding/:id"
              element={
                <ContentDashboard
                  title="راه اندازی لندینگ"
                  content={<InstallLanding />}
                />
              }
            />
            <Route
              path="showLandings"
              element={
                <ContentDashboard
                  title="نمایش لندینگ ها"
                  content={<ShowLandings />}
                />
              }
            />
            {/* <Route
              path="gallery"
              element={
                <ContentDashboard
                  title="گالری"
                  content={<Gallery />}
                />
              }
            /> */}

            <Route
              path="roles/edite/:id"
              element={
                <ContentDashboard
                  title="ویرایش نقش"
                  content={<EditeRole />}
                />
              }
            />
            <Route
              path="roles"
              element={
                <ContentDashboard
                  title="مدیریت نقش ها"
                  content={<RolesPage />}
                />
              }
            />

            <Route
              path="visits/:id"
              element={
                <ContentDashboard
                  title="جزئیات آمار"
                  content={<DetailStatistics />}
                />
              }
            />
            <Route
              path="visits"
              element={
                <ContentDashboard
                  title="آمار"
                  content={<ShowStatistics />}
                />
              }
            />
          </Route>
          {/* <Route path='/notfound' element={<Page404 />} /> */}
          <Route path="/*" element={<Page404 />} />
        </Routes>
      </div>

      <ToastContainer rtl />
    </myUserDataContext.Provider>
  );
};

export default App;
